import { DateTime } from 'luxon'
import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin(() => {
  return {
    provide: {
      luxon: DateTime,
    },
  }
})
